export default __webpack_public_path__ + "static/media/me-long.705eda76.jpg";